document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".faq-tab");
  const contents = document.querySelectorAll(".faq-content");

  if (tabs.length === 0 || contents.length === 0) return;

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));
      tab.classList.add("active");
      contents[index].classList.add("active");
    });
  });
});
